module.exports = __webpack_public_path__ + "img/stone-walls.09598852.png";